import React from 'react';
import { StarOutline, CircleOutlined, AttachFileOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { Pill } from '@/components/shared/Pill';
import { PillStatus } from '@/components/shared/Pill/types';

interface ImageTypeBadgeProps {
  type?: string;
}

export const ImageTypeBadge: React.FC<ImageTypeBadgeProps> = ({ type }) => {
  if (!type) return null;

  let icon: React.ReactNode = null;
  let label = '';
  let status: PillStatus = 'info';

  switch (type) {
    case 'primary':
      icon = <StarOutline />;
      label = 'Primary';
      status = 'success';
      break;
    case 'viewpoint':
      icon = <CircleOutlined />;
      label = 'Viewpoint';
      status = 'info';
      break;
    case 'attachment':
      icon = <AttachFileOutlined />;
      label = 'Attachment';
      status = 'info';
      break;
    default:
      break;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '10px',
        left: '10px',
      }}
    >
      <Pill label={label} icon={icon} showIcon size="medium" status={status} disabled />
    </Box>
  );
};
